import eventBus from '../event_bus'

export const SEGMENTATION_EVENT_SCOPE = 'segmentation_nav'
export const SEGMENTATION_EVENT_LOAD = 'segmentation_nav_load'
export const SEGMENTATION_EVENT_CHANGE = 'segmentation_nav_change'

function displaySelected (whichNav, selectedNavItem) {
  const allNavItems = whichNav.querySelectorAll('[data-segmentation-nav-link]')

  // display selected nav item
  allNavItems.forEach(navItem => {
    navItem.parentElement.classList.remove('segmentation-nav__item--is-selected')
  })

  selectedNavItem.parentElement.classList.add('segmentation-nav__item--is-selected')

  // display selected content block
  const targetContainerId = selectedNavItem.dataset.targetContainer
  const targetContentBlock = selectedNavItem.dataset.targetItem
  const contentBlocks = document.querySelectorAll(`${targetContainerId} .segmentation-element`)
  const selectedContentBlocks = document.querySelectorAll(`${targetContainerId} ${targetContentBlock}`)

  contentBlocks.forEach(block => {
    block.classList.add('is-hidden')
  })

  selectedContentBlocks.forEach(block => {
    block.classList.remove('is-hidden')
  })
}

function setupSelected () {
  const segmentationNavElements = document.querySelectorAll('[data-segmentation-nav-list]')

  segmentationNavElements.forEach(nav => {
    const initiallySelectedItem = nav.querySelector('.segmentation-nav__item--is-selected [data-segmentation-nav-link]')

    eventBus.emit(SEGMENTATION_EVENT_SCOPE, {
      message: SEGMENTATION_EVENT_LOAD,
      navigation: nav,
      initialSelectedItem: initiallySelectedItem
    })
  })
}

function selectNewSegment (e) {
  if (typeof e.target.closest !== 'function') return

  const thisNavItem = e.target.closest('[data-segmentation-nav-link]')

  if (thisNavItem) {
    const thisNav = e.target.closest('[data-segmentation-nav-list]')
    displaySelected(thisNav, thisNavItem)

    eventBus.emit(SEGMENTATION_EVENT_SCOPE, {
      message: SEGMENTATION_EVENT_CHANGE,
      navigation: thisNav,
      selectedItem: thisNavItem
    })
  }
}

function initSegmentationNav () {
  setupSelected()

  document.addEventListener('click', (e) => {
    selectNewSegment(e)
  })
}

document.addEventListener('DOMContentLoaded', initSegmentationNav)
